import List from './List.vue'
import Form from './Form.vue'

export default {
  install (Vue) {
    Vue.component('users-list', List)
    Vue.component('users-form', Form)
  }
}



// WEBPACK FOOTER //
// ./src/components/users/index.js